'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons';

import { Input } from '@/components/ui/input/input.component';
import { setOpenLocationSelectionModal } from '@/store/modal';
import { Place } from '@/types/google-maps.types';

interface LocationProps {
  className?: string;
  onSelectLocationCallback?: (userLocation?: Partial<Place>) => void;
  shouldScrollToBranchesListOnSelection?: boolean;
}

export function Location({
  className,
  onSelectLocationCallback,
  shouldScrollToBranchesListOnSelection,
}: LocationProps) {
  return (
    <section className={className}>
      <div
        className="block cursor-pointer"
        onClick={() => setOpenLocationSelectionModal(true, {
          locationCallback: onSelectLocationCallback,
          shouldScrollToBranchesListOnNavigate: shouldScrollToBranchesListOnSelection,
        })}
      >
        <Input
          data-testid={DataTestIdEnum.CITY_BRANCHES_NEAR_YOU_SECTION_INPUT}
          placeholder="Local de atendimento"
          startIcon={faMapMarkerAlt}
          startIconStyle="text-gray-800 w-5"
          className="pointer-events-none"
          shouldClearValue={false}
        />
      </div>
    </section>
  );
}
